module.exports = __webpack_public_path__ + "static/media/portal-icon.e38d501c.svg";